import { useQuery } from 'data-fetching-client';
import { GET_OBJECT_PROPERTIES_BY_GROUP } from 'automation-ui-references/object-type-properties/ObjectTypePropertyQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyLabel = ({
  objectTypeId,
  property
}) => {
  const {
    data: propertyData
  } = useQuery(GET_OBJECT_PROPERTIES_BY_GROUP, {
    variables: {
      objectTypeId
    }
  });
  const allProperties = propertyData === null || propertyData === void 0 ? void 0 : propertyData.automation_propertiesByGroup.flatMap(obj => obj.properties);
  const relevantProperty = allProperties === null || allProperties === void 0 ? void 0 : allProperties.find(obj => obj.name === property);
  if (!relevantProperty) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.labelError",
      options: {
        property
      }
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: relevantProperty.label
  });
};
export default PropertyLabel;